import React, { useState } from 'react';
import classes from './OTPSignup.module.css';
import { Col, Row } from 'react-bootstrap';
import Button from '../../Component/Button/Button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { WhiteLogo } from '../../constant/imagePath';
import Header from '../../Component/Header';
import { useDispatch } from 'react-redux';
// import Footer from '../../Component/Footer';
import { useTranslation } from 'react-i18next';
import { apiHeader, BaseURL } from '../../config/apiUrl';
import { toast } from 'react-toastify';
import OtpInput from 'react-otp-input';
import { Post } from '../../Axios/AxiosFunctions';
import { CountdownCircleTimer } from 'react-countdown-circle-timer';
import { saveLoginUserData } from '../../store/auth/authSlice';
import {
  setAllCompareList,
  setAllFavorite,
  setAllInquiryMessageAndRequest,
  setAllPropertyProjectsAndEvents,
  setAllSavedSearch
} from '../../store/notification/notificationSlice';

function OTPSignup() {
  const { t } = useTranslation('loginAndSignup');
  const d = (e) => t(`otpSignup.${e}`);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const emailParam = searchParams.get('email');
  const loginFlow = searchParams.get('login');
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [resend, setResend] = useState(true);
  const [formStates, setFormStates] = useState({
    otpCode: ''
  });

  function handleFormStateUpdate(key, value) {
    setFormStates({ ...formStates, [key]: value });
  }

  function userLogin(response) {
    dispatch(saveLoginUserData(response?.data));
    if (response?.data?.data?.propertyProjectsAndEvents) {
      dispatch(setAllPropertyProjectsAndEvents(response?.data?.data?.propertyProjectsAndEvents));
    }
    if (response?.data?.data?.favorite) {
      dispatch(setAllFavorite(response?.data?.data?.favorite));
    }
    if (response?.data?.data?.savedSearches) {
      dispatch(setAllSavedSearch(response?.data?.data?.savedSearches));
    }
    if (response?.data?.data?.compareList) {
      dispatch(setAllCompareList(response?.data?.data?.compareList));
    }
    if (response?.data?.data?.inquiryMessageAndRequest) {
      dispatch(setAllInquiryMessageAndRequest(response?.data?.data?.inquiryMessageAndRequest));
    }
    if (response?.data?.data?.user?.role == 'company') {
      navigate('/company/dashboard');
    } else if (response?.data?.data?.user?.role == 'agent') {
      navigate('/agent/dashboard');
    } else {
      navigate('/account-settings');
    }
  }

  async function onVerify() {
    setLoading(true);
    const response = await Post(
      BaseURL(`users/verify-user-otp`),
      { email: emailParam, otpCode: formStates.otpCode, fromForgotPassword: false },
      apiHeader()
    );

    if (response?.data) {
      toast.success(d('otpSuccess'));
      loginFlow == 'false' ? navigate('/login') : userLogin(response);
    } else {
      toast.error(d('otpError'));
    }
    setLoading(false);
  }

  const onResend = async () => {
    setResendLoading(true);

    try {
      const response = await Post(
        BaseURL(`users/resend-otp `),
        { email: emailParam, fromForgotPassword: false },
        apiHeader()
      );

      if (response) {
        setResend(true);
        toast.success(d('resendSuccess'));
      }
    } catch (error) {
      toast.error(d('resendError'));
    } finally {
      setResendLoading(false);
    }
  };

  const currentYear = new Date().getFullYear();

  return (
    <div>
      <Header />
      <div className={classes.bg}>
        <div className={classes.content}>
          <div className={classes.logoDiv}>
            <img src={WhiteLogo} />
          </div>
          <form
            className={classes.form}
            onSubmit={(e) => {
              e?.preventDefault();
              onVerify();
            }}>
            <Row className={classes.formRow}>
              <Col md={12}>
                <h4>{d('title')}</h4>
              </Col>
              <Col md={12} className={classes.desc}>
                <p>{d('desc')}</p>
              </Col>

              <Col md={12}>
                <div className={classes._inputContainer}>
                  <OtpInput
                    value={formStates?.otpCode}
                    onChange={(otpCode) => handleFormStateUpdate('otpCode', otpCode)}
                    numInputs={6}
                    renderInput={(props) => <input {...props} />}
                    shouldAutoFocus
                  />
                </div>
              </Col>

              <Col md={12} className={classes.desc}>
                <CountdownCircleTimer
                  key={resend ? 1 : 0}
                  isPlaying={resend}
                  duration={120}
                  size={100}
                  strokeWidth={6}
                  colors={'#00a997'}
                  onComplete={() => setResend(false)}>
                  {({ remainingTime }) => {
                    const minutes = Math.floor(remainingTime / 60);
                    const seconds = remainingTime % 60;

                    return (
                      <span
                        style={{ fontSize: '20px' }}
                        onClick={onResend}
                        className={!resend && classes.resendText}>
                        {resend
                          ? `0${minutes} : ${seconds < 10 ? '0' + seconds : seconds}`
                          : resendLoading
                          ? d('resending')
                          : d('resend')}
                      </span>
                    );
                  }}
                </CountdownCircleTimer>
              </Col>

              <Col md={12} className={classes.btns}>
                <Button type={'submit'} variant="secondary">
                  {loading ? d('loading') : d('verify')}
                </Button>
              </Col>
            </Row>
          </form>
          <p className={classes.copyRightText}>
            &copy;{currentYear} turegu. {d('allRightsReserved')}
          </p>
        </div>
      </div>
      {/* <Footer /> */}
    </div>
  );
}

export default OTPSignup;
